import { render, staticRenderFns } from "./BulmaMessage.vue?vue&type=template&id=20c37f35&scoped=true"
import script from "./BulmaMessage.vue?vue&type=script&lang=js"
export * from "./BulmaMessage.vue?vue&type=script&lang=js"
import style0 from "./BulmaMessage.vue?vue&type=style&index=0&id=20c37f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c37f35",
  null
  
)

export default component.exports